import { ProgrammingRow } from "@services/types/programming-edit/programmingEditTypes";

/**
 * Determines whether a stage violates its dependency constraint.
 * A violation occurs when the earliest start of the current stage
 * is before the latest end of the dependency stage.
 *
 * @param currentStageSlots - Slots assigned to the stage being validated.
 * @param dependencyStageSlots - Slots assigned to the dependency stage.
 * @returns `true` if the current stage has slots starting before the dependency finishes.
 */
export const hasStageDependencyViolation = (
  currentStageSlots: Pick<ProgrammingRow, "date" | "startTime">[],
  dependencyStageSlots: Pick<ProgrammingRow, "date" | "endTime">[],
): boolean => {
  if (currentStageSlots.length === 0 || dependencyStageSlots.length === 0) return false;

  const earliestStartOfCurrentStage = currentStageSlots
    .map(slot => `${slot.date} ${slot.startTime}`)
    .sort()[0];

  const latestEndOfDependencyStage = dependencyStageSlots
    .map(slot => `${slot.date} ${slot.endTime}`)
    .sort()
    .pop();

  return earliestStartOfCurrentStage < latestEndOfDependencyStage;
};
